var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaticoffsetheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2646px",
    height: "889px",
    viewBox: "0 0 2646 889",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "static offset header") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "static-offset-header",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#535353",
    x: 0,
    y: 0,
    width: 318,
    height: 202
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#535353",
    x: 0,
    y: 213,
    width: 318,
    height: 297
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#535353",
    x: 0,
    y: 604,
    width: 318,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#535353",
    x: 0,
    y: 521,
    width: 318,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#2264AA",
    x: 0,
    y: 687,
    width: 318,
    height: 202
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#2264AA",
    x: 388,
    y: 0,
    width: 318,
    height: 101
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#73BFB8",
    x: 776,
    y: 0,
    width: 318,
    height: 62
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    fill: "#2264AA",
    x: 388,
    y: 112,
    width: 318,
    height: 101
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#3DA5D9",
    x: 776,
    y: 73,
    width: 318,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#3DA5D9",
    x: 388,
    y: 224,
    width: 318,
    height: 149
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    fill: "#3DA5D9",
    x: 776,
    y: 120,
    width: 318,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    fill: "#3DA5D9",
    x: 776,
    y: 167,
    width: 318,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#2264AA",
    x: 388,
    y: 384,
    width: 318,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#3DA5D9",
    x: 776,
    y: 214,
    width: 318,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    fill: "#2264AA",
    x: 388,
    y: 448,
    width: 318,
    height: 239
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#3DA5D9",
    x: 776,
    y: 278,
    width: 318,
    height: 232
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    fill: "#2264AA",
    x: 388,
    y: 698,
    width: 318,
    height: 191
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    fill: "#3DA5D9",
    x: 776,
    y: 521,
    width: 318,
    height: 368
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#73BFB8",
    x: 1164,
    y: 788,
    width: 318,
    height: 101
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#FEC602",
    x: 1552,
    y: 853,
    width: 318,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    fill: "#73BFB8",
    x: 1164,
    y: 437,
    width: 318,
    height: 340
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    fill: "#FEC602",
    x: 1552,
    y: 437,
    width: 318,
    height: 405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    fill: "#FEC602",
    x: 1164,
    y: 101,
    width: 318,
    height: 325
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-29",
    fill: "#73BFB8",
    x: 1164,
    y: 2.84217094e-14,
    width: 318,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    fill: "#FEC602",
    x: 1552,
    y: 0,
    width: 318,
    height: 241
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-26",
    fill: "#F49D0D",
    x: 1552,
    y: 373,
    width: 318,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-27",
    fill: "#FEC602",
    x: 1552,
    y: 252,
    width: 318,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#F49D0D",
    x: 1940,
    y: 836,
    width: 318,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#EA5517",
    x: 2328,
    y: 798,
    width: 318,
    height: 91
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-28",
    fill: "#F49D0D",
    x: 1940,
    y: 772,
    width: 318,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-30",
    fill: "#EA5517",
    x: 1940,
    y: 644,
    width: 318,
    height: 117
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-35",
    fill: "#EA5517",
    x: 2328,
    y: 734,
    width: 318,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-37",
    fill: "#EA5517",
    x: 2328,
    y: 269,
    width: 318,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-39",
    fill: "#EA5517",
    x: 2328,
    y: 230,
    width: 318,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-40",
    fill: "#EA5517",
    x: 2328,
    y: 191,
    width: 318,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-41",
    fill: "#EA5517",
    x: 2328,
    y: 152,
    width: 318,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-38",
    fill: "#EA5517",
    x: 2328,
    y: 670,
    width: 318,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    fill: "#F49D0D",
    x: 1940,
    y: 307,
    width: 318,
    height: 326
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-36",
    fill: "#EA5517",
    x: 2328,
    y: 333,
    width: 318,
    height: 158
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-43",
    fill: "#EA5517",
    x: 2328,
    y: 502,
    width: 318,
    height: 157
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-42",
    fill: "#EA5517",
    x: 2328,
    y: 0,
    width: 318,
    height: 141
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-32",
    fill: "#F49D0D",
    x: 1940,
    y: 0,
    width: 318,
    height: 296
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#2264AA",
    strokeWidth: 3,
    points: "370.249102 0 345.918853 0 345.918853 772 333.823422 772"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-9",
    stroke: "#EA5517",
    strokeWidth: 3,
    points: "2312.2491 0 2287.91885 0 2287.91885 700.5 2275.82342 700.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy",
    stroke: "#3DA5D9",
    strokeWidth: 3,
    points: "760.249102 0 735.918853 0 735.918853 283.266168 723.823422 283.266168"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-5",
    stroke: "#FEC602",
    strokeWidth: 3,
    points: "1534.2491 0 1509.91885 0 1509.91885 283.266168 1497.82342 283.266168"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-7",
    stroke: "#F49D0D",
    strokeWidth: 3,
    points: "1924.2491 0 1899.91885 0 1899.91885 394.756806 1887.82342 394.756806"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-3",
    stroke: "#73BFB8",
    strokeWidth: 3,
    points: "1146.2491 -4.26325641e-14 1121.91885 -4.26325641e-14 1121.91885 27.4486669 1109.82342 27.4486669"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#2264AA",
    strokeWidth: 3,
    transform: "translate(352.212840, 837.000000) scale(1, -1) translate(-352.212840, -837.000000) ",
    points: "370.42568 785 346.09543 785 346.09543 889 334 889"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-10",
    stroke: "#EA5517",
    strokeWidth: 3,
    transform: "translate(2294.212840, 800.543564) scale(1, -1) translate(-2294.212840, -800.543564) ",
    points: "2312.42568 712.087128 2288.09543 712.087128 2288.09543 889 2276 889"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-2",
    stroke: "#3DA5D9",
    strokeWidth: 3,
    transform: "translate(742.212840, 593.328712) scale(1, -1) translate(-742.212840, -593.328712) ",
    points: "760.42568 297.657424 736.09543 297.657424 736.09543 889 724 889"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-6",
    stroke: "#FEC602",
    strokeWidth: 3,
    transform: "translate(1516.212840, 590.328712) scale(1, -1) translate(-1516.212840, -590.328712) ",
    points: "1534.42568 291.657424 1510.09543 291.657424 1510.09543 889 1498 889"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-8",
    stroke: "#F49D0D",
    strokeWidth: 3,
    transform: "translate(1906.212840, 647.366740) scale(1, -1) translate(-1906.212840, -647.366740) ",
    points: "1924.42568 405.733481 1900.09543 405.733481 1900.09543 889 1888 889"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-4",
    stroke: "#73BFB8",
    strokeWidth: 3,
    transform: "translate(1128.212840, 464.019913) scale(1, -1) translate(-1128.212840, -464.019913) ",
    points: "1146.42568 39.0398251 1122.09543 39.0398251 1122.09543 889 1110 889"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticoffsetheader);
export default __webpack_public_path__ + "static/media/staticoffsetheader.9958189d1e006776b143c1dba0bdecee.svg";
export { ForwardRef as ReactComponent };